import * as React from 'react';
import { connect } from 'react-redux';
import './css/ResultView.css';

import { onAddSinglePageOrSpread, onAddMultiPageOrSpread, onAddAgronomySpread, onAddMixedSpread} from '../../../../actions/actions';

export interface IAddCatalogPageComponentProps {
    onAddSinglePageOrSpread?(): void;
    onAddMultiPageOrSpread?(): void;
    onAddAgronomySpread?(): void;
    onAddMixedSpread?(): void;
  }

const mapDispatchToProps = (dispatch: any): any => {
    return {
      onAddSinglePageOrSpread: (): void => {
        dispatch(onAddSinglePageOrSpread());
      },
      onAddMultiPageOrSpread: (): void => {
        dispatch(onAddMultiPageOrSpread());
      },
      onAddAgronomySpread: (): void => {
        dispatch(onAddAgronomySpread());
      },
      onAddMixedSpread: (): void => {
        dispatch(onAddMixedSpread());
      }
    };
  };
  
  const mapStateToProps = (state: any): any => {
    return {
    };
  };
  
@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class AddCatalogPageComponent extends React.Component<IAddCatalogPageComponentProps> {
  constructor(props: any) {
    super(props);
  }

  onAddSinglePageOrSpread = () => {
    if (this.props.onAddSinglePageOrSpread != undefined) {
      this.props.onAddSinglePageOrSpread();
    }
  }
  onAddMultiPageOrSpread = () => {
    if (this.props.onAddMultiPageOrSpread != undefined) {
      this.props.onAddMultiPageOrSpread();
    }
  }
  onAddAgronomySpread = () => {
    if (this.props.onAddAgronomySpread != undefined) {
      this.props.onAddAgronomySpread();
    }
  }
  onAddMixedSpread = () => {
    if (this.props.onAddMixedSpread != undefined) {
      this.props.onAddMixedSpread();
    }
  }

  render() {
    return (
        <div className="add-catalog-page-container">
            <div className="add-catalog-page-title">
                Add Pages
            </div>
            <table>
                <tr className="add-catalog-page-container-row">
                    <td>
                        <button
                            className="add-catalog-page-button"
                            onClick={this.onAddSinglePageOrSpread}
                        >
                            <img src={require("./images/singlePages.svg")} className="add-catalog-page-button-image"></img>
                            <br/>
                            {'Single Products'}
                        </button>
                    </td>
                    <td>
                        <button
                            className="add-catalog-page-button"
                            onClick={this.onAddMultiPageOrSpread}
                        >
                            <img src={require("./images/multiplePages.svg")} className="add-catalog-page-button-image"></img>
                            <br/>
                            {'Multiple Products'}
                        </button>
                    </td>
                </tr>
                <tr className="add-catalog-page-container-row">
                    <td>
                        <button
                            className="add-catalog-page-button"
                            onClick={this.onAddAgronomySpread}
                        >
                            <img src={require("./images/agronomySpread.svg")} className="add-catalog-page-button-image"></img>
                            <br/>
                            {'Agronomy Spread'}
                        </button>
                    </td>
                    <td>
                        <button
                            className="add-catalog-page-button"
                            onClick={this.onAddMixedSpread}
                        >
                            <img src={require("./images/hybridPages.svg")} className="add-catalog-page-button-image"></img>
                            <br/>
                            {'Hybrid Pages'}
                        </button>
                    </td>
                </tr>
            </table>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Editor/components/Result/AddCatalogPageComponent.tsx